import React from "react";
import http from "../../util/api";
import qs from "qs";
import moment from "moment";
import "./Signature.scss";
import img1 from "./imgs/SHVO.png";
import img2 from "./imgs/doctor.png";
import { Toast, Button } from "antd-mobile";
import SignatureCanvas from "react-signature-canvas";
import BraftEditor from "braft-editor";
let timer;
class Signature extends React.Component {
  state = {
    title: "",
    toWrite: "",
    signature: null,
    REC_ID: "",
    showSigPad: false,
    trimmedDataURL: "",
    h: window.innerHeight,
    w: window.innerWidth - 48,
    name: "",
    fund: "",
    stTime: "",
    edTime: "",
    theme: "",
    speech: "",
    job: "",
    service: "",
    cost: "",
    id: "",
    BC: "",
    date: "",
    check1: false,
    check2: false,
    check3: false,
    check4: false,
    canSub: false,
    editorState: "",
    words2: "",
    showimage:0,
    imageurl:''
  };

  async componentDidMount() {
    const search = document.location.search;
    const querystring = search.substring(1);
    let id = qs.parse(querystring).id; //从url中取id
    let showimage = Number(qs.parse(querystring).showimage);
    let imageurl = qs.parse(querystring).imageurl;
    imageurl = decodeURI(imageurl);
    if(imageurl&&imageurl!='undefined'){
    this.setState({imageurl });
    }
    Toast.loading("登录中，请稍后…");
    await this.getToken();
    let myDateS = new Date();
    myDateS = moment(myDateS).format("YYYY-MM-DD");
    this.setState({ date: myDateS,showimage });
    await this.getRec(id);
  }
  constructor(props) {
    super(props);
    this.clear = this.clear.bind(this);
    this.trim = this.trim.bind(this);
  }
  sigCanvas = {
    clear: () => {},
    toDataURL: (param) => {
      return "";
    },
  };
  clear() {
    this.sigCanvas.clear();
    this.setState({ signature: null, trimmedDataURL: "" });
  }
  trim() {
    this.setState({
      showSigPad: false,
      signature: this.sigCanvas.toDataURL("image/png"),
      trimmedDataURL: this.sigCanvas.toDataURL("image/png"),
    });
    //let trimmedCanvas = this.sigCanvas.getTrimmedCanvas();
  }
  getToken = async () => {
    let res;
    let url = { baseURL: window.liveUrl };
    try {
      res = await http(url).login({
        code: "public",
        password: "123456",
      });
      let str = JSON.stringify(res.data);
      localStorage.setItem("userInfo", str);
      // await this.addRec();
    } catch (e) {
      console.log(e.message);
      Toast.fail("登录失败");
    }
  };
  getRec = async (id) => {
    Toast.loading("获取数据中", 0);
    let res;
    let url = { baseURL: window.liveUrl };
    try {
      res = await http(url).getTable({
        resid: 641478617353,
        cmswhere: `REC_ID = '${id}'`,
      });
      if (res.data.data[0].signature_time) {
        this.setState({
          canSub: false,
          check1: true,
          check2: true,
          check3: true,
          check4: true,
        });
      } else {
        this.setState({ canSub: true });
      }
      this.setState({
        name: res.data.data[0].name,
        fund: res.data.data[0].client,
        stTime: res.data.data[0].starttime,
        edTime: res.data.data[0].endtime,
        theme: res.data.data[0].event_topic,
        speech: res.data.data[0].speech_topic,
        job: res.data.data[0].service_name,
        service: res.data.data[0].service_type,
        cost: res.data.data[0].amount,
        id: res.data.data[0].ID,
        BC: res.data.data[0].bank_count,
        date: res.data.data[0].signature_time,
        signature: res.data.data[0].base64Picture,
        trimmedDataURL: res.data.data[0].base64Picture,
        REC_ID: res.data.data[0].REC_ID,

        editorState: BraftEditor.createEditorState(res.data.data[0].words),
        words2:(res.data.data[0].words2),
      });
      Toast.hide();
    } catch (e) {
      console.log(e.message);
      Toast.fail("数据获取失败");
    }
  };
  addRec = async () => {
    let res;
    let url = { baseURL: window.liveUrl };
    try {
      res = await http(url).saveLive({
        resid: 641478617353,
        data: '[{"_id":1,"_state":"added"}]',
      });
      this.setState({
        REC_ID: res.data.data[0].REC_ID,
        toWrite: res.data.data[0].C3_641478671690,
        title: res.data.data[0].C3_641478661509,
      });
      Toast.hide();
    } catch (e) {
      console.log(e.message);
      Toast.fail("登录失败");
    }
  };

  //将base64转换为blob
  dataURLtoBlob = (dataurl) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };
  //将blob转换为file
  blobToFile = (theBlob, fileName) => {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  };
  //调用

  submit = async () => {
    // if (
    //   this.state.check1 &&
    //   this.state.check2 &&
    //   this.state.check3 &&
    //   this.state.check4
    // ) {
    let url = { baseURL: window.liveUrl };

    if (this.state.signature) {
      Toast.loading("正在提交");
      let myDate = new Date();
      myDate = moment(myDate).format("YYYY-MM-DD");
      let obj = {
        REC_ID: this.state.REC_ID,
        base64Picture: this.state.signature,
        //   name:'张三',
        //   client:'1000',
        //   starttime:'20200506',
        //   endtime:'20200509',
        //   event_topic:'禽类营养讲座',
        //   speech_topic:'鸡汤应该在餐前喝还是餐后喝',
        //   service_name:'厨师',
        //   service_type:'烹饪午餐',
        //   amount:'200',
        //  ID:'32019800808044X',
        //  bank_count:'1234567890ab',
        signature_time: myDate,
      };
      let res2 = await http(url).modifyRecords({
        resid: 641478617353,
        data: [obj],
      });
      this.setState({ canSub: false });
      Toast.success("提交成功");
    } else {
      Toast.fail("您还没有签名");
    }
    // }
    // else {
    //   Toast.fail("请勾选所有服务和工作内容！");
    // }
  };

  handleChange = (editorState) => {
    this.setState({ editorState, outputHTML: editorState.toHTML() });
  };
  render() {
    let { trimmedDataURL, editorState, words2,showimage,imageurl } = this.state;
    const controls = [];
    return (
      <div className="content_sig">
        <BraftEditor
          onChange={this.handleChange}
          controls={controls}
          readOnly={true}
          value={editorState}
          contentStyle={{ height: "100%" }}
        />
        {/* <h3>服务确认书</h3>
    <p>尊敬的<b>{this.state.name}</b>（先生/女士）:</p>
    <p>上海大億宝信息科技有限公司受<b>{this.state.fund}</b>委托将于<b>{this.state.stTime}至{this.state.edTime}</b>，开展<b>{this.state.theme}</b>专题的在线患教活动，根据要求，现诚挚邀请您参与此次活动，并提供相关服务和工作。</p>
<ul>
    <li>
      <input id='1' name='1' type='checkbox' checked={this.state.check1} onChange={()=>{this.setState({check1:true});}}/>
      <label htmlFor='1'>提供相关的讲课课件，患者协调工作</label>
    </li>
    <li>
      <input id='2' name='2' type='checkbox' checked={this.state.check2} onChange={()=>{this.setState({check2:true});}}/>
      <label htmlFor='2'>发表主题为<b>{this.state.speech}</b>的演讲</label>
    </li>
    <li>
      <input id='3' name='3' type='checkbox' checked={this.state.check3} onChange={()=>{this.setState({check3:true});}}/>
      <label htmlFor='2'>担任活动<b>{this.state.job}</b>一职</label>
    </li>
    <li>
      <input id='4' name='4' type='checkbox' checked={this.state.check4} onChange={()=>{this.setState({check4:true});}}/>
      <label htmlFor='4'>提供<b>{this.state.service}</b>咨询服务</label>
      </li>
</ul>
<p>(请勾选以上相关服务内容)</p>
    <p>作为您提供上述劳务的对价，我司将于劳务提供之日起30日内通过银行转账向您支付报酬人民币<b>{this.state.cost}</b>元整。
    </p><p><b style={{border:'none',fontWeight:'bold'}}>您的签署或盖章即表明对与上海大億宝信息科技有限公司建立此次劳务关系的确认。</b></p>
    <p>身份证号码：<b>{this.state.id}</b></p>
    <p>银行账号：<b>{this.state.BC}</b></p>
    <p><b>{this.state.date}</b></p>
     */}
        <p>签名：</p>
        {!this.state.signature ? (
          <>
            <div
              className="blank"
              onClick={() => {
                this.setState({ showSigPad: true });
              }}
            >
              点击开始签名
            </div>
          </>
        ) : (
          <>
            <img
              ref="img"
              style={{ maxHeight: "calc(100vh - 14rem)" }}
              onClick={() => {
                if (this.state.canSub) {
                  this.setState({ showSigPad: true });
                }
              }}
              src={this.state.signature}
            />
          </>
        )}
        <div className="btnLine">
          {this.state.canSub ? (
            <Button
              type="primary"
              className="submit"
              onClick={() => {
                this.submit();
              }}
            >
              提交
            </Button>
          ) : null}
        </div>
        <div className={this.state.showSigPad ? "sigPad" : "hidden"}>
          <div className="titleLine">
            <Button
              size="small"
              type="primary"
              onClick={() => {
                this.trim();
              }}
            >
              确定
            </Button>
            <Button
              size="small"
              onClick={() => {
                this.setState({ showSigPad: false });
              }}
            >
              取消
            </Button>
            <Button
              size="small"
              style={{ float: "left" }}
              onClick={() => {
                this.clear();
              }}
            >
              清空
            </Button>
          </div>
          <div className="paper">
            <SignatureCanvas
              penColor="green"
              canvasProps={{
                width: this.state.w,
                height: this.state.h,
                className: "sigCanvas",
              }}
              ref={(ref) => {
                this.sigCanvas = ref;
              }}
            />
          </div>
        </div>
        {
          showimage===1?
            <div className="imgLine">
              <img src={imageurl?imageurl:img2} />
            </div>
          :null
        }
        <div style={{textAlign:'left'}} dangerouslySetInnerHTML={{__html:words2}}>
        </div>
      </div>
    );
  }
}

export default Signature;
